module.exports = __webpack_public_path__ + "img/ch07_08_让座.13a1c854.jpg";